import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const ENDPOINT = "/plugins/org.graylog.plugins.forwarder/forwarder/inputs/metrics";
const POLL_INTERVAL_MS = 6e4;
export const compositeIdFor = ({ input_id, forwarder_node_id }) => `${input_id}:${forwarder_node_id}`;
const buildQuery = (compositeIds, fields) => [
  ...compositeIds.map((id) => `input_ids=${encodeURIComponent(id)}`),
  ...fields.map((field) => `fields=${encodeURIComponent(field)}`)
].join("&");
export const fetchForwarderInputMetrics = (compositeIds, fields) => fetch("GET", qualifyUrl(`${ENDPOINT}?${buildQuery(compositeIds, fields)}`));
const sortedUnique = (values) => Array.from(new Set(values)).sort();
const useForwarderInputMetrics = (pairs, fields) => {
  var _a;
  const stableIds = sortedUnique(pairs.map(compositeIdFor));
  const stableFields = sortedUnique(fields);
  const enabled = stableIds.length > 0 && stableFields.length > 0;
  const { data, isInitialLoading, isError } = useQuery({
    queryKey: ["forwarder", "inputs", "metrics", stableIds, stableFields],
    queryFn: () => defaultOnError(
      fetchForwarderInputMetrics(stableIds, stableFields),
      "Loading forwarder input metrics failed with status",
      "Could not load forwarder input metrics"
    ),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: POLL_INTERVAL_MS
  });
  return {
    metricsByPair: (_a = data == null ? void 0 : data.metrics) != null ? _a : {},
    isInitialLoading,
    isError
  };
};
export default useForwarderInputMetrics;
